import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Event } from './types'

export const EVENTS_QUERY: TypedDocumentNode<
  { events: Event[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Events($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    events(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id title description date_start date_end label place image image_low_res observations created_at updated_at
    }
  }
`

export const EVENT_QUERY: TypedDocumentNode<{ event: Event | null }, { id: string }> = gql`
  query Event($id: ID!) {
    event(id: $id) {
      id client_id application_id title description date_start date_end label place image image_low_res observations created_at updated_at
    }
  }
`
